import React from "react";

const STYLES = {
  error: {
    wrapper:
      "bg-gradient-to-r from-red-50 to-pink-50 border-l-4 border-red-500 text-red-800 animate-shake",
    icon: "bg-red-500",
    symbol: "!",
  },
  success: {
    wrapper:
      "bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 text-green-800 animate-bounce-in",
    icon: "bg-green-500",
    symbol: "✓",
  },
};

/**
 * Message d'erreur ou de succès pour le formulaire d'auth
 */
const AuthMessage = ({ type, message }) => {
  if (!message) return null;
  const s = STYLES[type];
  return (
    <div className={`${s.wrapper} px-5 py-4 rounded-2xl shadow-lg`}>
      <div className="flex items-center gap-3">
        <div
          className={`w-8 h-8 ${s.icon} rounded-full flex items-center justify-center flex-shrink-0`}
        >
          <span className="text-white font-bold">{s.symbol}</span>
        </div>
        <span className="font-medium">{message}</span>
      </div>
    </div>
  );
};

export default AuthMessage;
